import { render } from "./TableCalls.vue?vue&type=template&id=777ac7be&scoped=true"
import script from "./TableCalls.vue?vue&type=script&lang=js"
export * from "./TableCalls.vue?vue&type=script&lang=js"

import "./TableCalls.vue?vue&type=style&index=0&id=777ac7be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777ac7be"]])

export default __exports__